export default function isDefaultLanguage(value, options) {
	return value === "default";
}
